import {
  Button,
  Text,
  tokens,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
} from '@fluentui/react-components';
import { WarningRegular } from '@fluentui/react-icons';
import { format } from 'date-fns';
import type { DrakeMatchStatus } from '../../types';
import { matchStatusDisplayNames } from './types';
import type { DuplicateDialogProps } from './types';

export default function DuplicateDialog({
  open,
  onOpenChange,
  existingChecklist,
  taxYear,
  pendingFile,
  fileInputRef,
  handleFileUpload,
  setExistingChecklistForDuplicate,
  setPendingFile,
}: DuplicateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
      <DialogSurface style={{ maxWidth: '500px' }}>
        <DialogBody>
          <DialogTitle>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <WarningRegular style={{ color: tokens.colorPaletteMarigoldForeground1 }} />
              Duplicate Checklist Found
            </div>
          </DialogTitle>
          <DialogContent>
            <Text as="p">
              A checklist for <strong>{existingChecklist?.extractedClientInfo?.name}</strong> already exists for tax year {taxYear}.
            </Text>
            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: tokens.colorNeutralBackground3, borderRadius: '4px' }}>
              <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
                Existing checklist extracted on:{' '}
                {existingChecklist?.extractionMetadata?.extractedAt
                  ? format(new Date(existingChecklist.extractionMetadata.extractedAt), 'MMM d, yyyy h:mm a')
                  : 'Unknown'}
              </Text>
              <br />
              <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
                Items: {existingChecklist?.checklistItems?.length || 0} documents
              </Text>
              <br />
              <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
                Status: {matchStatusDisplayNames[existingChecklist?.matchStatus as DrakeMatchStatus] || 'Unknown'}
              </Text>
            </div>
            <Text as="p" style={{ marginTop: '16px' }}>
              Do you want to overwrite the existing checklist with the new data?
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              onClick={() => {
                onOpenChange(false);
                setPendingFile(null);
                setExistingChecklistForDuplicate(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
              }}
            >
              Cancel
            </Button>
            <Button
              appearance="primary"
              onClick={() => {
                onOpenChange(false);
                if (pendingFile) {
                  const dataTransfer = new DataTransfer();
                  dataTransfer.items.add(pendingFile);
                  handleFileUpload(dataTransfer.files, true);
                }
                setPendingFile(null);
                setExistingChecklistForDuplicate(null);
              }}
            >
              Overwrite
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
